import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Table } from '../../../libs/proto/restaurant_pb';
import { Product } from '../../../libs/proto/shop_pb';

@Injectable({
  providedIn: 'root'
})
export class RestaurantTableConversionService {

  constructor() { }

  ToStorage(req: Table) {
    const w = new BinaryWriter();
    Table.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  ToFromStorage(data: any, callback: (news: Table, errorConvert: any) => void) {
    try {
      callback( Table.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(news: Table[]) {
    const rets = new Array<Uint8Array | number[]>();

    news.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (news: Table[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Table>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Table.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
